export const SoldDataShareEvenType = {
  ShareSearch: 'share-search',
};

export default {
  SoldDataShareEvenType,
};
